import React from 'react';
import Type from 'prop-types';
import { getIn } from 'formik';
import { DatePicker } from '@material-ui/pickers';

const DatePickerField = ({ field, form, ...other }) => {
  const { name } = field;
  const { errors, setFieldError, setFieldValue } = form;

  const fieldError = getIn(errors, name);
  const showError = !!fieldError;

  return (
    <DatePicker
      {...field}
      helperText={fieldError}
      error={showError}
      onError={error => {
        // handle as a side effect
        if (error !== fieldError) {
          setFieldError(name, error);
        }
      }}
      // if you are using custom validation schema you probably want to pass `true` as third argument
      onChange={date => setFieldValue(name, date, false)}
      {...other}
    />
  );
};

DatePickerField.propTypes = {
  form: Type.object.isRequired, // eslint-disable-line react/forbid-prop-types
  field: Type.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default DatePickerField;
